import sections from "./sections.json";
export const englishDomain = sections.domains.englishDomain;
export const germanDomain = sections.domains.germanDomain;

export const getOtherDomain = currentLocale => {
  switch (currentLocale) {
    case "en":
      return englishDomain;
    case "de":
      return germanDomain;
    default:
      return germanDomain;
  }
};
